/**
 * Resolve a column's `field` against a row.
 *
 * Tabulator treats a dot in `field` as a path into nested row data, and some
 * models rely on it — sso/internalRole renders a count as
 * `_count.InternalRoleToInternalUser`. A plain `row[field]` lookup returns
 * undefined for those and the column silently renders blank, so every place
 * that reads a cell's raw value goes through here.
 *
 * A literal key that happens to contain dots wins over the path walk, matching
 * Tabulator, which only descends when the whole key is absent.
 */
export function getFieldValue(row, field) {
  if (!row || !field) return undefined;
  if (Object.prototype.hasOwnProperty.call(row, field)) return row[field];
  if (field.indexOf(".") === -1) return undefined;

  return field.split(".").reduce((acc, part) => {
    if (acc === null || acc === undefined) return undefined;
    return acc[part];
  }, row);
}
